module.exports = __webpack_public_path__ + "static/media/top_referral.1fb8fff9.svg";